module.exports = __webpack_public_path__ + "img/enseption_03.194a8de3.png";